import { isDefined } from "@ls/js-utils";
import scope from "./scope";

export default class CashFlowDefinition {
  static getDefault = () =>
    new CashFlowDefinition({
      period: "p30dCashFlow",
      type: "netCashFlow",
    });

  #period;
  #type;

  constructor(props = {}) {
    const { period, type } = props;

    this.#period = period;
    this.#type = type;
  }

  get period() {
    return this.#period;
  }

  get type() {
    return this.#type;
  }

  get key() {
    return `${scope} - ${this.#period}, ${this.#type}`;
  }

  get complete() {
    return isDefined(this.period) && isDefined(this.type);
  }

  copy = () => {
    return {
      period: this.period,
      type: this.type,
    };
  };

  setPeriod = (value) =>
    new CashFlowDefinition({
      ...this.copy(),
      period: value,
    });

  setType = (value) =>
    new CashFlowDefinition({
      ...this.copy(),
      type: value,
    });
}
